module.exports = __webpack_public_path__ + "9805c57794b16277e8eac120f16684cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-12.png
// module id = 3205
// module chunks = 0